import React, { useState, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import './AdminBlog.css';

function AdminBlog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingPost, setEditingPost] = useState(null);
  const [formData, setFormData] = useState({
    title: '',
    excerpt: '',
    content: '',
    image: '',
    tags: '',
    readTime: 5,
    isPublished: true
  });
  const [showForm, setShowForm] = useState(false);

  // دریافت لیست مقالات
  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const response = await axios.get('https://api.chekidesara.ir/api/admin/blog/posts');
      setPosts(response.data.data);
    } catch (error) {
      console.error('Error fetching posts:', error);
      toast.error('خطا در دریافت مقالات');
    } finally {
      setLoading(false);
    }
  };

  // تبدیل تگ‌ها به آرایه
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const postData = {
      ...formData,
      tags: formData.tags.split(',').map(tag => tag.trim())
    };

    try {
      let response;
      if (editingPost) {
        response = await axios.put(`https://api.chekidesara.ir/api/admin/blog/post/${editingPost._id}`, postData);
        toast.success('مقاله با موفقیت ویرایش شد');
      } else {
        response = await axios.post('https://api.chekidesara.ir/api/admin/blog/post', postData);
        toast.success('مقاله با موفقیت ایجاد شد');
      }
      
      setShowForm(false);
      setEditingPost(null);
      setFormData({
        title: '',
        excerpt: '',
        content: '',
        image: '',
        tags: '',
        readTime: 5,
        isPublished: true
      });
      fetchPosts();
    } catch (error) {
      console.error('Error saving post:', error);
      toast.error(error.response?.data?.message || 'خطا در ذخیره مقاله');
    }
  };

  const handleEdit = (post) => {
    setEditingPost(post);
    setFormData({
      title: post.title,
      excerpt: post.excerpt,
      content: post.content,
      image: post.image || '',
      tags: post.tags?.join(', ') || '',
      readTime: post.readTime,
      isPublished: post.isPublished
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('آیا از حذف این مقاله مطمئن هستید؟')) {
      try {
        await axios.delete(`https://api.chekidesara.ir/api/admin/blog/post/${id}`);
        toast.success('مقاله حذف شد');
        fetchPosts();
      } catch (error) {
        console.error('Error deleting post:', error);
        toast.error('خطا در حذف مقاله');
      }
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingPost(null);
    setFormData({
      title: '',
      excerpt: '',
      content: '',
      image: '',
      tags: '',
      readTime: 5,
      isPublished: true
    });
  };

  if (loading) {
    return <div className="admin-loading">در حال بارگذاری...</div>;
  }

  return (
    <div className="admin-blog">
      <div className="admin-blog-header">
        <h2>📝 مدیریت مقالات</h2>
        <button className="btn-add-post" onClick={() => setShowForm(!showForm)}>
          {showForm ? '✖ بستن فرم' : '+ مقاله جدید'}
        </button>
      </div>

      {/* فرم ایجاد/ویرایش مقاله */}
      {showForm && (
        <div className="blog-form-container">
          <h3>{editingPost ? 'ویرایش مقاله' : 'مقاله جدید'}</h3>
          <form onSubmit={handleSubmit} className="blog-form">
            <div className="form-group">
              <label>عنوان مقاله *</label>
              <input
                type="text"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                required
              />
            </div>

            <div className="form-group">
              <label>خلاصه مقاله (توضیح کوتاه) *</label>
              <textarea
                rows="3"
                value={formData.excerpt}
                onChange={(e) => setFormData({ ...formData, excerpt: e.target.value })}
                required
              />
            </div>

            <div className="form-group">
              <label>متن کامل مقاله *</label>
              <textarea
                rows="10"
                value={formData.content}
                onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                required
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>آدرس تصویر (اختیاری)</label>
                <input
                  type="text"
                  placeholder="https://..."
                  value={formData.image}
                  onChange={(e) => setFormData({ ...formData, image: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label>تگ‌ها (با کاما جدا کنید)</label>
                <input
                  type="text"
                  placeholder="آموزش زبان, کتاب انگلیسی, آیلتس"
                  value={formData.tags}
                  onChange={(e) => setFormData({ ...formData, tags: e.target.value })}
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>زمان مطالعه (دقیقه)</label>
                <input
                  type="number"
                  min="1"
                  max="60"
                  value={formData.readTime}
                  onChange={(e) => setFormData({ ...formData, readTime: parseInt(e.target.value) })}
                />
              </div>

              <div className="form-group checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.isPublished}
                    onChange={(e) => setFormData({ ...formData, isPublished: e.target.checked })}
                  />
                  منتشر شود
                </label>
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-save">
                {editingPost ? 'ویرایش مقاله' : 'ایجاد مقاله'}
              </button>
              <button type="button" className="btn-cancel" onClick={handleCancel}>
                انصراف
              </button>
            </div>
          </form>
        </div>
      )}

      {/* لیست مقالات */}
      <div className="blog-table-container">
        <table className="blog-table">
          <thead>
            <tr>
              <th>عنوان</th>
              <th>تاریخ انتشار</th>
              <th>بازدید</th>
              <th>وضعیت</th>
              <th>عملیات</th>
            </tr>
          </thead>
          <tbody>
            {posts.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-data">هیچ مقاله‌ای وجود ندارد</td>
              </tr>
            ) : (
              posts.map(post => (
                <tr key={post._id}>
                  <td className="post-title">{post.title}</td>
                  <td>{new Date(post.publishedAt).toLocaleDateString('fa-IR')}</td>
                  <td>{post.views || 0}</td>
                  <td>
                    <span className={`status-badge ${post.isPublished ? 'published' : 'draft'}`}>
                      {post.isPublished ? 'منتشر شده' : 'پیش‌نویس'}
                    </span>
                  </td>
                  <td className="actions">
                    <button className="btn-edit" onClick={() => handleEdit(post)}>✏️</button>
                    <button className="btn-delete" onClick={() => handleDelete(post._id)}>🗑️</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AdminBlog;